/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBracketsCurly: {
  name: 'brackets-curly';
  data: string;
} = {
  name: 'brackets-curly',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4a2 2 0 0 1 2-2h1a1 1 0 0 1 0 2H5v5.586A2 2 0 0 1 4.414 11l-1 1 1 1A2 2 0 0 1 5 14.414V20h1a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2v-5.586l-1.707-1.707a1 1 0 0 1 0-1.414L3 9.586V4Zm6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2-17a1 1 0 1 0 0 2h1v5.586A2 2 0 0 0 19.586 11l1 1-1 1A2 2 0 0 0 19 14.414V20h-1a1 1 0 1 0 0 2h1a2 2 0 0 0 2-2v-5.586l1.707-1.707a1 1 0 0 0 0-1.414L21 9.586V4a2 2 0 0 0-2-2h-1Z" fill="currentColor"/></svg>`,
};
